import React, { useContext, useEffect, useState } from 'react';
import { BasketOutlined } from 'jl-design-system/components/icons/BasketOutlined';
import { BasketAmount } from '../basket-amount/BasketAmount';
import { EnvVarsFeaturesContext } from '../../scaffold/EnvVarsFeaturesContext';
import { UserContext } from '../../scaffold/UserContext';
import { isMin1024pxWide } from '../../utils/device/identifyDevice';
import { notifyNavAnalytics } from '../navigation/notify-analytics';
import { getUserProfileFromCookies } from '../../../client/getUserProfileFromCookies';

const isClient = () => typeof window !== 'undefined' && window.document;

export const Basket = () => {
  const [componentMounted, setComponentMounted] = useState(false);

  const {
    envVars: { headerMinibasketActive },
  } = useContext(EnvVarsFeaturesContext);

  const {
    userState: {
      user: {
        basket: { items },
      },
    },
    updateUserState,
  } = useContext(UserContext);

  const handleUserProfileUpdate = () => {
    if (isClient()) {
      const userProfile = getUserProfileFromCookies();
      updateUserState(userProfile);
    }
  };

  const handleBasketButtonClick = (
    event: React.MouseEvent<HTMLAnchorElement>
  ) => {
    if (isClient() && headerMinibasketActive && window.isMinibasketLoaded) {
      event.preventDefault();
      const customEvent = new global.window.CustomEvent(
        'jl-events.browser.showMinibasket',
        {
          detail: {
            source: 'page-level',
          },
        }
      );
      window.dispatchEvent(customEvent);
    }
    if (!isMin1024pxWide()) {
      notifyNavAnalytics('mv', 'Basket');
    }
  };

  useEffect(function listenForBasketQuantityUpdates() {
    if (!componentMounted) {
      window.addEventListener(
        'jl-events.browser.basketQuantityUpdated',
        handleUserProfileUpdate,
        false
      );
      setComponentMounted(true);
    }

    return function stopListeningForBasketQuantityUpdates() {
      window.removeEventListener(
        'jl-events.browser.basketQuantityUpdated',
        handleUserProfileUpdate,
        false
      );
    };
  }, []);

  let label = 'View your basket';
  if (items > 0) {
    label = `View your basket, ${items} item${items > 1 ? 's' : ''}`;
  }
  return (
    <a
      id="minibasket-icon-anchor"
      onClick={event => handleBasketButtonClick(event)}
      href="/basket"
      data-test="basket-anchor"
      data-testid="basket-anchor"
      aria-label={label}
    >
      <BasketAmount basketItems={items} />
      <BasketOutlined size="large" title="View your basket" />
    </a>
  );
};
